import { render, staticRenderFns } from "./PollingChoiceContactsPage.vue?vue&type=template&id=59dbf3df&scoped=true&"
import script from "./PollingChoiceContactsPage.vue?vue&type=script&lang=js&"
export * from "./PollingChoiceContactsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dbf3df",
  null
  
)

export default component.exports